import { useQuery } from '@tanstack/react-query';

import {
  DEFAULT_QUERY_GC_TIME_MS,
  DEFAULT_QUERY_STALE_TIME_MS,
} from '../utils/queryCache.constants';
import { LEAD_QUERY_KEYS } from '../utils/leadApi.constants';
import { getCitiesByRegion } from '../services';
import { mapCities } from '../mappers';

export function useGetCities(idRegion) {
  const n = Number(idRegion);
  const regionId = Number.isFinite(n) && n > 0 ? n : null;

  return useQuery({
    queryKey: LEAD_QUERY_KEYS.cities(regionId),
    queryFn: async () => {
      const dto = await getCitiesByRegion(regionId);
      return mapCities(dto);
    },
    enabled: regionId != null,
    staleTime: DEFAULT_QUERY_STALE_TIME_MS,
    gcTime: DEFAULT_QUERY_GC_TIME_MS,
  });
}
